/** @file Route definitions for the course enrollment sub-pages. */
import { lazyLoadView } from '@/components/higher_order/LazyLoader';
import { getDefault, NO_STUDENT_VIEW } from '../utils';
/**
 * Returns a meta object for a course enrollment sub-route.
 *
 * @param readableName The human-readable name for the route.
 * @returns The route meta object.
 */
function getMeta(readableName) {
    return {
        loginRequired: false,
        hideSidebar: true,
        hideFooter: true,
        readableName,
        getStudentViewPage: NO_STUDENT_VIEW,
    };
}
export default [
    {
        path: '/courses/:courseId/enroll/:linkId',
        name: 'course_enroll',
        component: lazyLoadView({
            getComponent: () => import('@/pages/CourseEnroll').then(getDefault),
            errorMessage: 'Could not load course enroll page.',
        }),
        meta: getMeta('Course Enrollment'),
    },
    {
        path: '/courses/:courseId/enroll/:linkId/login/:tenantId',
        name: 'course_enroll_login',
        component: lazyLoadView({
            getComponent: () => import('@/pages/CourseEnroll/Login').then(getDefault),
            errorMessage: 'Could not load course enroll login page.',
        }),
        meta: getMeta('Course Enrollment - Login'),
    },
    {
        path: '/courses/:courseId/enroll/:linkId/login-otp',
        name: 'course_enroll_login_otp',
        component: lazyLoadView({
            getComponent: () => import('@/pages/CourseEnroll/LoginOTP').then(getDefault),
            errorMessage: 'Could not load course enroll OTP page.',
        }),
        meta: getMeta('Course Enrollment - One-time Password'),
    },
    {
        path: '/courses/:courseId/enroll/:linkId/register/:tenantId',
        name: 'course_enroll_register',
        component: lazyLoadView({
            getComponent: () => import('@/pages/CourseEnroll/Register').then(getDefault),
            errorMessage: 'Could not load course enroll register page.',
        }),
        meta: getMeta('Course Enrollment - Register'),
    },
    {
        path: '/courses/:courseId/enroll/:linkId/register-otp/:pendingRegistrationId',
        name: 'course_enroll_register_otp',
        component: lazyLoadView({
            getComponent: () => import('@/pages/CourseEnroll/RegisterOTP').then(getDefault),
            errorMessage: 'Could not load course enroll register OTP page.',
        }),
        meta: getMeta('Course Enrollment - Registration One-time Password'),
    },
    {
        path: '/courses/:courseId/enroll/:linkId/select-account/:session',
        name: 'course_enroll_select_account',
        component: lazyLoadView({
            getComponent: () => import('@/pages/CourseEnroll/SelectAccount').then(getDefault),
            errorMessage: 'Could not load course enroll select account page.',
        }),
        meta: getMeta('Course Enrollment - Select Account'),
    },
];
